import React from 'react'

import { UserAvatar } from '@avantstay/backoffice-core'
import { formatDateRange } from '@avantstay/format-date-range'

import {
  BookingBasicResult,
  OmniSearchUser,
} from '@/_new/__global/components/OmniSearch/OmniSearch.types'

import * as S from './UserDetail.styles'

export interface UserDetailProps {
  user: OmniSearchUser
}

function UserDetail({ user }: UserDetailProps): JSX.Element {
  const { fullName, email, ongoing, next } = user

  const renderBookingCard = (booking?: BookingBasicResult) => {
    if (!booking) return <></>

    return (
      <>
        <S.DetailTitle>
          {formatDateRange(
            booking.checkInTiming.effectiveTime,
            booking.checkOutTiming.effectiveTime,
          )}
        </S.DetailTitle>
        <S.DetailSubtitle>
          {booking.home.region?.name ?? ''} &bull; {booking.home.name}
        </S.DetailSubtitle>
      </>
    )
  }

  return (
    <S.UserDetail>
      <S.UserDetailColumn>
        <UserAvatar alt={fullName} size={35} isActive solid />
      </S.UserDetailColumn>
      <S.UserDetailColumn>
        <S.DetailTitle>{fullName}</S.DetailTitle>
        <S.DetailSubtitle>{email}</S.DetailSubtitle>
      </S.UserDetailColumn>
      <S.UserDetailColumn>
        {renderBookingCard(ongoing)}
        {renderBookingCard(next)}
      </S.UserDetailColumn>
    </S.UserDetail>
  )
}

export default UserDetail
